import React, { useCallback } from 'react';
import cx from 'classnames';
import { useHistory, useRouteMatch } from 'react-router-dom';
import PropTypes from 'prop-types';

import { NotificationManager } from '@atlas/core';
import { BasePopup, Button, Icon, Label } from '@atlas/ui';

import { urlSeparator } from 'common/constants';

export const ErrorPopup = ({ data = {}, id }) => {
  const { push } = useHistory();
  const { url } = useRouteMatch();
  const backUrlArray = url.split(urlSeparator);
  backUrlArray.pop();

  const { className, text = 'something_went_wrong_contact_support', title } = data;

  const handleClose = useCallback(() => {
    NotificationManager.removeNotification(id);
  }, [id]);

  const handleOk = () => {
    handleClose();
    push(backUrlArray.join(urlSeparator));
  };

  return (
    <BasePopup className={cx('error-modal', className)}>
      <div className="popup__content">
        <Icon className="error-modal__icon" name="error" />
        <Label className="popup__title" message={title} />
        <Label className="popup__text" message={text} />
      </div>

      <div className="popup__footer">
        <Button className="primary big block" label="ok" onClick={handleOk} />
      </div>
    </BasePopup>
  );
};

ErrorPopup.propTypes = {
  data: PropTypes.object,
  id: PropTypes.string.isRequired,
};
